/*
  type getComponentClassHelper = (componentName: string) => (subClass: string) => string;

  ---

  A lightweight HOC to expose a helper function for a React component
  to generate a class name with a high level of specificity.

  Intended to be defined at the top level within a component file.

  ---

  Example usage within a React component file:

    import React from 'react';
    // ...
    const componentClass = getComponentClassHelper('MyComponentName');
    
    const MyComponentName = props => {
      return (
        <div className={componentClass()}>
          <div className={componentClass('header')}></div>
          <div className={componentClass('section-body')}></div>
        </div>
      );
    };

  Resulting DOM structure:

    <div classname="MyComponentName">
      <div classname="MyComponentName--header"></div>
      <div classname="MyComponentName--section-body"></div>
    </div>

  This reflects how much of our SCSS is written:

    .MyComponentName {
      &--header {}
      &--section-body {}
    }
*/

const getComponentClassHelper = componentName => subClass =>
  subClass ? `${componentName}--${subClass}` : componentName;

export default getComponentClassHelper;
